import { useState, useEffect } from "react"


export default function SearchContainer(){

    useEffect(() => {

    },[]);


    return (
        <div class="ltn__car-dealer-form-area mt--65 mt-120 pb-115---">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="ltn__car-dealer-form-tab">
                                <div class="ltn__tab-menu  text-uppercase d-none">
                                    <div class="nav">
                                        <a data-bs-toggle="tab" href="#ltn__form_tab_1_2" class=""><i class="far fa-user"></i>Cerca casa</a>
                                    </div>
                                </div>
                                <div class="tab-content bg-white box-shadow-1 ltn__border position-relative pb-10">
                                    <div class="tab-pane fade active show" id="ltn__form_tab_1_1">
                                        <div class="car-dealer-form-inner">
                                            <form action="#" class="ltn__car-dealer-form-box row">
                                                
                                                <div class="ltn__car-dealer-form-item ltn__custom-icon---- ltn__icon-meter---- col-lg-3 col-md-6">
                                                    <select class="nice-select">
                                                        <option value="1">Vendita</option>
                                                        <option value="2">Affitto</option>
                                                    </select>
                                                </div> 
                                                <div class="ltn__car-dealer-form-item ltn__custom-icon---- ltn__icon-calendar---- col-lg-3 col-md-6">
                                                    <select class="nice-select">
                                                        <option value="19">Villetta a schiera</option>
                                                        <option value="20">Appartamento</option>
                                                        <option value="21">Loft</option>
                                                        <option value="22">Villa</option>
                                                        <option value="23">Palazzo</option>
                                                        <option value="24">Attico</option>
                                                        <option value="25">Rustico - Casale</option>
                                                        <option value="26">Casa indipendente</option>
                                                        <option value="27">Palazzo - Stabile</option>
                                                        <option value="28">Garage - box</option>
                                                        <option value="29">Posto auto</option>
                                                        <option value="30">Ufficio</option>
                                                        <option value="31">Immobile</option>
                                                        <option value="32">Negozio - Locale commerciale</option>
                                                        <option value="33">Capannone</option>
                                                        <option value="34">Terreno</option>
                                                        <option value="35">Terreno Agricolo</option>
                                                        <option value="36">Terreno edificabile</option>
                                                        <option value="37">Terreno non edificabile</option>
                                                        <option value="38">Magazzino - Deposito</option>
                                                        <option value="39">Coworking</option>
                                                    </select>
                                                </div>

                                                <div class="ltn__car-dealer-form-item ltn__custom-icon---- ltn__icon-car---- col-lg-3 col-md-6">
                                                    <input type="text" className="nice-select" placeholder="Comune"/>
                                                </div> 
                                                <div class="ltn__car-dealer-form-item ltn__custom-icon ltn__icon-calendar col-lg-3 col-md-6">
                                                    <div class="btn-wrapper text-center mt-0">
                                                        
                                                        <a href="" class="btn theme-btn-1 btn-effect-1 text-uppercase">Cerca</a>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
    );
}